import './QuickStartSection.css';

const steps = [
  {
    num: '01',
    title: 'Integrate Payout API',
    body: 'Connect through our REST API and authenticate with your key. Start building in the sandbox straight away.',
    items: ['REST API and SDKs', 'Sandbox access', 'Idempotency built in'],
  },
  {
    num: '02',
    title: 'Fund your wallet',
    body: 'Add funds to your settlor.money wallet over NEFT or RTGS. Check the balance anytime through the balance API.',
    items: ['NEFT and RTGS funding', 'Live balance API', 'Multi-wallet setup'],
  },
  {
    num: '03',
    title: 'Initiate payouts',
    body: 'Trigger single or bulk payouts via API. Set the beneficiary, amount and rail, and smart routing handles the rest.',
    items: ['Single and bulk payouts', 'Smart multi-bank routing', 'Scheduled runs'],
  },
  {
    num: '04',
    title: 'Track via webhooks',
    body: 'Get real-time status updates through signed webhooks. Query the status API anytime for any transaction.',
    items: ['Signed webhooks', 'Status API', 'Per-event delivery logs'],
  },
];

export default function QuickStartSection() {
  return (
    <section className="quickstart">
      <div className="quickstart__container">
        <div className="quickstart__header">
          <p className="quickstart__eyebrow">Quick start</p>
          <h2 className="quickstart__heading">Get started quickly</h2>
          <p className="quickstart__subheading">Four steps from your API key to live, tracked payouts.</p>
        </div>
        <div className="quickstart__grid">
          {steps.map((s, i) => (
            <div key={i} className="quickstart__step">
              <p className="quickstart__num">{s.num}</p>
              <h3 className="quickstart__title">{s.title}</h3>
              <p className="quickstart__body">{s.body}</p>
              <ul className="quickstart__list">
                {s.items.map((item, j) => (
                  <li key={j} className="quickstart__item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none" className="quickstart__check">
                      <path d="M10.0916 0.757812L3.67497 7.17448L0.758301 4.25781" stroke="#0043FE" strokeWidth="1.51667" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
